<template lang="pug">
div.job-opening
  div.job-detail.job-post(v-if="currentOpening")
    div.banner.text-center.relative
      div
        h1.text-white {{ currentOpening.title }}
        p.text-white {{ currentOpening.location }} - {{ currentOpening.type }}
    div.container
      div.row.padding-left-xs-1.padding-right-xs-1
        div.margin-top-xs-1.margin-top-sm-1.margin-bottom-xs-1.margin-bottom-sm-1(v-html="currentOpening.transpiled")
  div.job-listing.job-list.padding-bottom-sm-1(v-if="openings.length")
    div.container
      h2.text-center.margin-top-sm-1.margin-bottom-sm-1.margin-top-xs-1.margin-bottom-xs-1 {{ currentOpening? 'All Our Jobs' : 'Interested? Come join us!' }}
      ul.list.row.padding-left-xs-0.padding-right-xs-0.padding-bottom-sm-1.padding-bottom-xs-1
        li.list-item(v-for="opening in openings")
          div.list-content.text-center
            h3.mb0.uppercase {{ opening.title }} #[br] #[span.small] {{ opening.location }}
            p(style="flex-grow: 1") {{ opening.excerpt }}
            p.small.text-center
              a.uppercase.underline(:href="`#${opening.id}`", @click.prevent.stop="openingId = opening.id") Read More  
</template>

<script>

export default {

  components : {    
  },

  props : ['id'],

  name: 'job-opening',

  data() {

    return {

      openingId : null,
      openings : [],
      currentOpening : null,
      hash : null,

      // Generic properties
      eventHub : window.vueEventHub || new Vue()

    }
  },

  computed : {
    
  },

  watch : {
    'openingId' : async function(val, old) {
      if (!!val) {
        this.currentOpening = await this.fetchOpening()
        await this.$nextTick()
        setTimeout(() => {
          document.querySelector('.job-opening').scrollIntoView({ block : 'start', behavior : 'smooth' })        
        }, 50)
        this.switchTemplate('job-detail', val)        
      } else {
        this.currentOpening = null
        this.switchTemplate('job-listing', null)
      }
    }
  },

  async created() {

    this.hash = await this.fetchHash()
    if (!this.hash) this.hash = ((new Date().getTime()) / 1000 * 3600) >> 0

    this.openingId = this.id
    this.openings = await this.fetchListing()

    if (this.openingId !== null) {
      this.switchTemplate('job-detail', this.openingId)
      this.currentOpening = await this.fetchOpening()
      if (!this.currentOpening) {
        this.switchTemplate('job-listing', null)
      }
    } else {
      this.switchTemplate('job-listing', null)
    }

    window.addEventListener('hashchange', evt => {
      if (window.location.hash === '') {
        this.openingId = null
      }
    })

  },

  methods : {

    switchTemplate(name, hash = null) {

      if (name === 'job-listing')
        document.body.classList.remove('job-detail')
      else if (name === 'job-detail')
        document.body.classList.remove('job-listing')

      document.body.classList.add(name)

      if (hash) {
        window.location.hash = hash
      } else {
        window.location.hash = ''
      }
    },

    fetchHash() {
      return fetch(`//${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}/api-cache/5m/JobOpening?fn=getHash`)
        .then(res => res.json())
        .then(data => data.data)
    },

    fetchListing() {
      return fetch(`//${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}/api-cache/30m/JobOpening?fn=getJobOpenings&hash=${this.hash}`)
        .then(res => res.json())
        .then(data => data.data)
    },

    fetchOpening() {
      return fetch(`//${ConstantsManager.CASETAGRAM_BASE_DOMAIN_CDN}/api-cache/30m/JobOpening?fn=getJobOpenings&id=${this.openingId}&hash=${this.hash}`)
        .then(res => res.json())
        .then(data => data.data)
    },

    cdnImage(src) {
      return `${CDN_URL_PREFIX}${src}`
    }

  }
}
</script>

<style lang="scss">
.job-list {
  background-color: #f2f2f2;
}
.job-post {
  h3 {
    font-size: 24px;
    line-height: 1.8em;  
    margin-top: 2em;
  }

  h3 + ul {
    margin-top: 10px;
  }

  li {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.8em;
  }
  p {
    font-size: 18px;
    line-height: 400;
    line-height: 1.8em;
  }
}
.job-opening {

  .banner {
    background-image: url("//cdn.casetify.com/img/career_page/career-office2.jpg");
    background-size: cover;
    background-position: center;
    height: 400px;    
    > div {
      position: absolute;
      top: 50%;
      left: 0;
      width: 100%;
      transform: translateY(-50%);
    }
  }
  ul.list {
    display: flex;
    flex-wrap: wrap;
    .list-item {

      display: flex;
      padding: .5em;
      width: 100%;

      .list-content {
         display: flex;
         flex-direction: column;
         background-color: #fff;
         padding: 1em;
         width: 100%;
      }    

      @media all and (min-width: 40em) {
        width: 50%;
      }
      @media all and (min-width: 60em) {
        width: 33.33%;
      }

    }
  }

}
</style>


// WEBPACK FOOTER //
// CMSJobOpening.vue?402e35ca